import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import styles from './Dropdown.module.scss';
import { getDefaultSelectStyles } from './Dropdown.constants';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
import { TooltipWrapper } from '../TooltipWrapper';
import { SvgIcon, SvgIconSrc } from '../SvgIcon';
export const DropdownComponent = ({
  options,
  value,
  onChange,
  isLoading,
  isDisabled,
  classNamePrefix,
  selectStyles,
  label,
  errorMessage,
  placeholder,
  isMulti,
  width,
  tooltip,
  isCreatable,
  onCreateOption,
}) => {
  const SelectComponent = isCreatable ? CreatableSelect : Select;
  return (
    <div className={styles.dropdownContainer} style={{ width }}>
      {label && (
        <div className={styles.labelContainer}>
          <Text
            variant={textVariantsEnum.Text_13}
            fontWeight={fontWeightEnum.Medium}
            className={styles.label}
          >
            {label}
          </Text>
          {tooltip && (
            <TooltipWrapper tooltip={tooltip} wrapperClassName="mb-2">
              <SvgIcon src={SvgIconSrc.info} color="gray-400" size={16} />
            </TooltipWrapper>
          )}
        </div>
      )}
      <SelectComponent
        isMulti={isMulti}
        options={options}
        menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
        value={value}
        onChange={onChange}
        menuPosition="fixed"
        isLoading={isLoading}
        isDisabled={isDisabled}
        placeholder={placeholder}
        classNamePrefix={classNamePrefix}
        onCreateOption={onCreateOption}
        styles={{
          ...getDefaultSelectStyles(selectStyles),
        }}
      />
      {!!errorMessage && (
        <Text
          variant={textVariantsEnum.Text_13}
          fontWeight={fontWeightEnum.Regular}
          color="error-500"
        >
          {errorMessage}
        </Text>
      )}
    </div>
  );
};
